export default __webpack_public_path__ + "static/b_radler_05-3cf3c80416ccf831d0d91e9aa569f52a.png";